<template lang="pug">
	section(:class="{'force-mobile': forceMobile}")
		form
			p.mb-4(v-if="showRegister")
				| Don’t have a Savingforcollege.com account?
				span.link.cursor-pointer.ml-2.underline(@click="register")
					| Register
			.row
				.pr-5(:class="{'col-md-6': !forceMobile,'col-md-12': forceMobile }")
					.social-container
						//- a.social-button.facebook(:href="facebookUrl")
							.logo
								img(:src="`${$store.state.config.s3ResourceHost}/images/facebook-logo.svg`" alt="")
							.text
								| LOG IN WITH FACEBOOK
						a.social-button.google(:href="googleUrl")
							.logo
								img(:src="`${$store.state.config.s3ResourceHost}/images/google-logo.svg`" alt="Google Logo")
							.text
								| LOG IN WITH GOOGLE
					.divider-container
						span.text OR USE YOUR EMAIL
						.line
					div.mt-4
						label
							| Email
						sfc-input-v2.text-input(v-model="email" type="text" :error="emailError" :error-message="emailErrorMessage" inputmode="email" :scroll-on-focus="true" :scroll-container="`.sfc-onboarding-mobile-v3`" name="email")
					div.mt-4
						label
							| Password
						span.underline.float-right.cursor-pointer(@click="togglePwd" v-if="inputType == 'password'")
							| Show
						span.underline.float-right.cursor-pointer(@click="togglePwd" v-if="inputType != 'password'")
							| Hide
						sfc-input-v2.text-input(v-model="password" :type="inputType" :scroll-on-focus="true" :scroll-container="`.sfc-onboarding-mobile-v3`" name="password")
						.text-right.mt-2
							span.underline.cursor-pointer(@click="forgotPwd")
								| Forgot your password?

			.continue-button.mt-5
				sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")
				sfc-button(text="LOG IN" :blue="true" :continue-arrow="true" @click="next" :loading="loading")

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
.social-container
	margin-top: 20px
	.social-button
		color: #fff
		border: 1px solid
		overflow: hidden
		border-radius()
		cursor: pointer
		display: block
		&:hover
			color: #fff
		.logo
			display: inline-block
			width: 50px
			text-align: center
			padding: 9px 0
		&.facebook
			border-color: #2353b1
			background-color: #3e71d5
			.logo
				background-color: #275ec7
				border-right: 1px solid #2353b1
		&.google
			margin-top: 30px
			border-color:  #4d8cf5
			background-color: #4c8bf5
			.logo
				background-color: #fff
		.text
			padding-left: 20px
			display: inline-block
			@media(max-width: 767px)
				font-size: body-font-size

.divider-container
	margin-top: 30px
	margin-bottom: 30px
	text-align: center
	.text
		font-size: body-font-size-xs
		color: sfc-gray-dark
		background-color: #fff
		padding: 0 15px
	.line
		margin-top: -15px
		border-top: 1px solid sfc-pale-gray-light
</style>


<script>

import SfcButton from '@/common/components/sfc-button'
import SfcInputV2 from '@/common/components/inputs/v2/textbox'
import UMFunctions from "@/lib/primary_functions.js"
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	props: {
		forceMobile: {
			default: false
		}
	},

	components:{
		SfcButton,
		SfcInputV2
	},

	data() {
		return {
			emailError: false,
			emailErrorMessage: null,
			pwdError: false,
			pwdErrorMessage: null,
			email: null,
			password: null,
			progressLength: 15,
			showPassword: false,
			loading: false,
			showRegister: false,
			facebookUrl: `/auth/facebook?action=login`,
			googleUrl: `/auth/google_oauth2?action=login`
		}
	},

	computed: {
		inputType(){
			if(this.showPassword){
				return "text"
			}else{
				return "password"
			}
		},

	},

	mounted() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type == 'updateCollegeSavingsUserOnboarding' && mutation.payload.part == "next_step_v3" && mutation.payload.value){
				this.showRegister = true
			}
		})
		this.showRegister = !!this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
	},

	methods: {

		togglePwd(){
			this.showPassword = !this.showPassword
		},

		validateEmail(){
			const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

			if (!emailRegex.test(this.email)) {
				this.emailError = true
				this.emailErrorMessage = "Please enter a valid email"
				return false
			}

			this.emailError = false
			this.emailErrorMessage = ""

			return true
		},

		validatePwd(){
			if (!this.password || this.password.trim() == "") {
				this.pwdError = true
				this.pwdErrorMessage = 'Required'
				return false
			}
			this.pwdError = false
			this.pwdErrorMessage = ''
			return true
		},

		back(){
			this.$emit('next', -1*this.progressLength, "How can we help you today?", "sfc-how-can-we-help-you-today", false, true)
		},

		register(){
			this.$emit(
				'next',
				0,
				"Create your account",
				"sfc-create-your-account",
				{
					progressLength: this.progressLength,
					title: "Log In to your account",
					component: "sfc-log-in-to-your-account"
				}
			)
		},

		forgotPwd(){
			this.$emit('next', 0, "Forgot your password", "sfc-forgot-your-password")
		},

		async signin(){
			if(!this.validateEmail() || !this.validatePwd())	return
			this.emailErrorMessage = ""
			this.loading = true
			let result

			let umFunctions = new UMFunctions(this.$cookies, this.$store, this.$httpService)
			result = await umFunctions.login(this.email, this.password)

			if (!result) {
				this.emailErrorMessage = "Invalid email or password"
				this.emailError = true
				this.loading = false
				return
			}else{
				this.emailErrorMessage = ""
				this.emailError = false
			}

			this.afterLoginCheck()
		},

		async afterLoginCheck(){

			let token = this.$cookies.get("sfc_primary")
			let collegeSavingsUser = undefined
			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`
			try {
				let result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
				this.loading = false
				this.emailErrorMessage = "There was an error. Please, try again."
				this.emailError = true
				return
			}


			if (collegeSavingsUser == undefined || !collegeSavingsUser){
				this.emailErrorMessage = "There was an error. Please, try again."
				this.emailError = true
				this.loading = false
				return
			}

			if(collegeSavingsUser ){
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

				SfcTrackingService.trackAnalyticsAction("Savings Center", "Onboarding", "Login", 0)

				let collegeSavingsUserString = JSON.stringify(collegeSavingsUser)
				this.$cookies.set("savings-center-info", collegeSavingsUserString, {
					// path: '/',
					// domain: 'savingforcollege.com',
					maxAge: 365 * 24 * 60 * 60
				})
				return window.location.href = "/savings-center/" + collegeSavingsUser.next_step_v3
			}else{
				this.$emit('next', 0, "What is your state of residence?", "sfc-what-is-your-state-of-residence")
			}

		},
		next(){
			this.signin()
		},
	}

}
</script>
